import Editor from "@/components/editor/Editor.vue";
import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
import { mapState } from "vuex";
import TestEmailTemplateDialog from "@/views/settings/emailTemplates/email-view/TestEmailTemplateDialog.vue";
import { EditorStyles } from "@/components/editor/EditorStyles";
import EmailDialogDelete from "@/views/settings/emailTemplates/email-dialog-delete/EmailDialogDelete.vue";
import juice from "juice";
import firebase from "firebase";
import EmailDialogChangeType from "@/views/settings/emailTemplates/email-dialog-change-type/EmailDialogChangeType.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";

export default {
  components: {
    Editor,
    TestEmailTemplateDialog,
    EmailDialogDelete,
    EmailDialogChangeType,
    ConfirmDlg
  },
  data() {
    return {
      isOpenTestEmailDialog: false,
      emailTemplatesTypes: Object.values(DefaultEmailTemplateType).map((x) => { return { name: x, isDefault: true } }),
      facilityEmailTemplateTypeList: [],
      isEmailTemplateTypeChanged: false,
      prevEmailTemplate: null,
    }
  },
  computed: {
    ...mapState({
      emailTemplate: state => (state as any).facilityModule.currentEmailTemplate,
      facilityEmailTemplateTypes: state => (state as any).facilityModule.facilityEmailTemplateTypes
    }),
    DefaultEmailTemplatesTypes() {
      return DefaultEmailTemplateType;
    },
    Message() {
      return this.emailTemplate.isEnabled == true && this.emailTemplate.type != DefaultEmailTemplateType.ServiceRequestToVendor?
        "This template is enabled, please enable a different template of this type before deleting" :
        "Are you sure you want to delete this template?"
    },
    isCustomEmailTemplate() {
      return this.emailTemplate.type !== this.DefaultEmailTemplatesTypes.StaffUserInvite &&
        this.emailTemplate.type !== this.DefaultEmailTemplatesTypes.FamilyUserInvite &&
        this.emailTemplate.type !== this.DefaultEmailTemplatesTypes.BroadcastEmail &&
        this.emailTemplate.type !== this.DefaultEmailTemplatesTypes.ServiceApproval &&
        this.emailTemplate.type !== this.DefaultEmailTemplatesTypes.FamilyAppProfileDeletion;
    }
  },
  async created() {
    await this.$store.dispatch("getEmailTemplate", this.$route.params.id);
    await this.$store.dispatch("getFacilityEmailTemplateTypes");
    this.prevEmailTemplate = {...this.$store.state.facilityModule.currentEmailTemplate}
  },
  watch: {
    facilityEmailTemplateTypes(types) {
      this.facilityEmailTemplateTypeList = types.concat(this.emailTemplatesTypes)
    }
  },
  methods: {
    async setEmailTemplateType(selectedType, e) {

      const currentType = this.prevEmailTemplate.type || this.prevEmailTemplate.typeId
      const currentTypeName = this.facilityEmailTemplateTypeList.find(x=>x.id == currentType || x.name == currentType).name
      const { name : selectedTypeName, isDefault: isDefault = false } = this.facilityEmailTemplateTypeList.find(x=>x.id == selectedType || x.name == selectedType)
      
      if(currentTypeName != selectedTypeName){
        const facilityId = this.$store.state.authModule.currentFacility
        const docs: any[] = (await firebase.firestore()
        .collection('emailTemplates')
        .where('facilityId', '==', facilityId)
        .where(this.prevEmailTemplate.type && this.prevEmailTemplate.type.length?'type':'typeId', '==', currentType).get()).docs.map(x => ({ id: x.id, ref: x.ref,...x.data()}));
        const enabled = docs.filter(x => x.isEnabled == true && x.id != this.prevEmailTemplate.id)

        if(!enabled.length){
          this.emailTemplate.type = this.prevEmailTemplate.type
          this.emailTemplate.typeId = this.prevEmailTemplate.typeId
          this.$refs.confirmMessageDlgRef.open(null,
            `This template cannot be changed to <b>${selectedTypeName}</b> because there are no other enabled templates of type <b>${currentTypeName}</b>. Please enable some template for <b>${currentTypeName}</b>.`,
            false, '', { noconfirm: true, yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Ok'] })
            return
        }

      }

      if (isDefault) {
        this.emailTemplate.type = selectedType
        this.emailTemplate.typeId = ''
      }
      else {
        this.emailTemplate.typeId = selectedType
        this.emailTemplate.type = ''
      }
      this.isEmailTemplateTypeChanged = true;
    },
    editorLoaded(): void {
      console.log("editorLoaded");
    },
    editorReady(): void {
      console.log("editorReady");
    },
    openTestEmailDialog(): void {
      this.isOpenTestEmailDialog = true;
    },
    routeToEmailTemplates() {
      this.$router.push("/settings?tab=emailTemplates");
    },
    async save() {
      try {
        if (this.isEmailTemplateTypeChanged) {

          const isEmailTemplateAnotherTypeEnabled = await this.checkEmailTemplatesOnEnabled();

          if (isEmailTemplateAnotherTypeEnabled && this.emailTemplate.isEnabled) {
            this.$refs.emailDialogChangeType.open(null, `There is already an email template enabled for that type. This template will be disabled if you proceed with this change`, false).then(async response => {
              if (response && response.agree) {
                await this.checkTemplateProperties();
                this.emailTemplate.html = juice.inlineContent(this.emailTemplate.html || '', EditorStyles);
                this.emailTemplate.isEnabled = false;
                await this.$store.dispatch("updateEmailTemplate", this.emailTemplate);
                this.routeToEmailTemplates();
              }
            })
          } else {
            await this.checkTemplateProperties();
            this.emailTemplate.html = juice.inlineContent(this.emailTemplate.html || '', EditorStyles);
            await this.$store.dispatch("updateEmailTemplate", this.emailTemplate);
            this.routeToEmailTemplates();
          }
        } else {
          this.updateEmailTemplate()
        }
      } catch (e) {
        console.error(e);
      }
    },
    async onEnableTemplate(isEnable) {

      const groupedTemplates = (await this.getGroupedDefaultEmailTemplatesByCurrentType());
      if (!isEnable && this.emailTemplate.type.length && groupedTemplates.enabled.length == 0 && groupedTemplates.disabled.length == 0) {
        
        this.emailTemplate.isEnabled = true;

        (this.$refs.confirmMessageDlgRef as any).open(null,
          `This template cannot be disabled as there is no other templates of this type. Please create a new <b>${this.emailTemplate.type}</b> before disabling this one`,
          false, '', { noconfirm: true, yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Ok']})
          return
      }
      else if (!isEnable && this.emailTemplate.type.length > 0 && groupedTemplates.enabled.length == 0 && groupedTemplates.disabled.length > 0) {
        
        this.emailTemplate.isEnabled = true;

        (this.$refs.confirmMessageDlgRef as any).open(null,
          `This template cannot be disabled as there will be no enabled templates of this type. Please enable another <b>${this.emailTemplate.type}</b> which will automatically disable this one`,
          false, '', { noconfirm: true, yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Ok'] })
          return
      }else{
        this.emailTemplate.isEnabled = isEnable
      }
    },
    async updateEmailTemplate() {
      await this.checkTemplateProperties();
      this.emailTemplate.html = juice.inlineContent(this.emailTemplate.html || '', EditorStyles);
      await this.$store.dispatch("updateEmailTemplate", this.emailTemplate);
      this.routeToEmailTemplates();
    },
    async checkTemplateProperties() {
      const templateDataProperties = [];

      if (this.emailTemplate.html.includes("residentName")) {
        templateDataProperties.push({ propertyName: 'residentName', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("familyUserName")) {
        templateDataProperties.push({ propertyName: 'familyUserName', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("familyMemberName")) {
        templateDataProperties.push({ propertyName: 'familyMemberName', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("familyMemberImageUrl")) {
        templateDataProperties.push({ propertyName: 'familyMemberImageUrl', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("familyMemberEmail")) {
        templateDataProperties.push({ propertyName: 'familyMemberEmail', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("setPasswordLink")) {
        templateDataProperties.push({ propertyName: 'setPasswordLink', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("serviceRef")) {
        templateDataProperties.push({ propertyName: 'serviceRef', propertyValue: '' })
      }

      if (this.emailTemplate.html.includes("serviceName")) {
        templateDataProperties.push({ propertyName: 'serviceName', propertyValue: '' })
      }

      if(this.emailTemplate.html.includes("vendorName")) {
        templateDataProperties.push({propertyName: 'vendorName', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("serviceRequestId")) {
        templateDataProperties.push({propertyName: 'serviceRequestId', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("completeServiceRequestUrl")) {
        templateDataProperties.push({propertyName: 'completeServiceRequestUrl', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("requesterName")) {
        templateDataProperties.push({propertyName: 'requesterName', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("requestDate")) {
        templateDataProperties.push({propertyName: 'requestDate', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("paymentType")) {
        templateDataProperties.push({propertyName: 'paymentType', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("amount")) {
        templateDataProperties.push({propertyName: 'amount', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("serviceDescription")) {
        templateDataProperties.push({propertyName: 'serviceDescription', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("ref")) {
        templateDataProperties.push({propertyName: 'ref', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("oldEmailAddress")) {
        templateDataProperties.push({propertyName: 'oldEmailAddress', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("facilityName")) {
        templateDataProperties.push({propertyName: 'facilityName', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("staffHubURL")) {
        templateDataProperties.push({propertyName: 'staffHubURL', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("username") || this.emailTemplate.html.includes("userName")) {
        templateDataProperties.push({propertyName: 'username', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("requestFamilyAppLink")) {
        templateDataProperties.push({propertyName: 'requestFamilyAppLink', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("myHubAppName")) {
        templateDataProperties.push({propertyName: 'myHubAppName', propertyValue:''})
      }

      if (this.emailTemplate.html.includes("familyHubAppName") || this.emailTemplate.subject.includes("familyHubAppName")) {
        templateDataProperties.push({ propertyName: 'familyHubAppName', propertyValue: '' })
      }

      if(this.emailTemplate.html.includes("emailVerificationLink")) {
        templateDataProperties.push({propertyName: 'emailVerificationLink', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("linkToFamilyHubForIos")) {
        templateDataProperties.push({propertyName: 'linkToFamilyHubForIos', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("linkToFamilyHubForAndroid")) {
        templateDataProperties.push({propertyName: 'linkToFamilyHubForAndroid', propertyValue:''})
      }

      if (this.emailTemplate.html.includes("notificationTitle") || this.emailTemplate.subject.includes("notificationTitle")) {
        templateDataProperties.push({ propertyName: 'notificationTitle', propertyValue: '' })
      }

      if(this.emailTemplate.html.includes("notificationContent")) {
        templateDataProperties.push({propertyName: 'notificationContent', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("unsubscribe")) {
        templateDataProperties.push({propertyName: 'unsubscribe', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("familyDeletionLink")) {
        templateDataProperties.push({propertyName: 'familyDeletionLink', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("familyHubAppName")) {
        templateDataProperties.push({propertyName: 'familyHubAppName', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("surveyLink") || this.emailTemplate.html.includes("surveylink")) {
        templateDataProperties.push({propertyName: 'surveyLink', propertyValue:''})
      }

      if(this.emailTemplate.html.includes("surveyName") || this.emailTemplate.html.includes("surveyname")) {
        templateDataProperties.push({propertyName: 'surveyName', propertyValue:''})
      }

      this.emailTemplate.templateDataProperties = templateDataProperties;
    },
    async checkEmailTemplatesOnEnabled() {

      let query = null
      const facilityId = this.$store.state.authModule.currentFacility

      if (this.emailTemplate.type) {
        query = firebase.firestore().collection('emailTemplates').where('facilityId', '==', facilityId).where('type', '==', this.emailTemplate.type)
      }
      else if (this.emailTemplate.typeId) {
        query = firebase.firestore().collection('emailTemplates').where('facilityId', '==', facilityId).where('typeId', '==', this.emailTemplate.typeId)
      }

      return (await query.get()).docs.map(x => ({ id: x.id, ...x.data() }))
        .some((x: any) => x.isEnabled == true)
    },

    async getGroupedDefaultEmailTemplatesByCurrentType() {
      const templates = (await firebase
        .firestore()
        .collection("emailTemplates")
        .where("facilityId", "==", this.$store.state.authModule.currentFacility)
        .where(firebase.firestore.FieldPath.documentId(), "!=", this.emailTemplate.id) //skip current
        .where("type", "==", this.emailTemplate.type)//type - default email type | typeId custom email type
        .get()).docs.map(x => ({ id: x.id, ...x.data() }))

      const groupedTemplates = {
        enabled: templates.filter((x: any) => x.isEnabled == true),
        disabled: templates.filter((x: any) => x.isEnabled == false),
      }

      return groupedTemplates
    },
    async remove() {

      const groupedTemplates = (await this.getGroupedDefaultEmailTemplatesByCurrentType());

      if(groupedTemplates.enabled.length == 0 && groupedTemplates.disabled.length == 0){
        (this.$refs.confirmMessageDlgRef as any).open(null,
          `This template cannot be deleted as there is no other templates of this type. Please create a new <b>${this.emailTemplate.type}</b> before deleting this one`,
          false, '', { noconfirm: true, yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Ok']})
          .then(() => {
            return
          })
      }
      else{
        this.$refs.confirmationModal.open(null, this.Message, false, "", null, this.emailTemplate.isEnabled)
        .then(response => {
          if (response && response.agree) {
            this.$store.dispatch(
              "deleteEmailTemplate",
              this.emailTemplate.id
            ).then(() => {
              this.$router.push("/settings?tab=emailTemplates");
            })
          }
        })
      }
    
    }
  }
};
